import AssistClasses from './AssistClasses.js'
import formats from '../../api/formats'
import dialogs from '../common/dialogs.js'
import forms from '../common/forms.js'
import people from '../people'
import SimpleField from './fields/SimpleField'
import CompanyField from './fields/CompanyField'
import JsonField from './fields/JsonField'
import HoldersField from './fields/HoldersField'
import CompanyFilesField from './fields/CompanyFilesField'
import CalcField from './fields/CalcField'
import IndividualField from './fields/IndividualField'
import ContactField from './fields/ContactField'
import PersonDocField from './fields/PersonDocField'
import CompanyBankField from './fields/CompanyBankField'
import ActionField from './fields/ActionField'

class Step extends AssistClasses.Step {
  constructor (cxt) {
    super('Укажите данные для создания документа',
      null,
      {
        scheme: []
      },
      {
      })
    this.context = cxt
    this.editable = true
    this.refMap = new Map()
    this.fieldObjects = new Map()
    this.items = []
  }
  calcHeighEditor (rows, type) {
    if (type === 'macro') {
      rows = rows > 0 ? rows : 1
      return (rows * 20 + 18) + 'px'
    }
    rows = rows > 0 ? rows : 6
    return (rows * 20 + 32) + 'px'
  }
  fillFields (fields) {
    // const ruleInn = v => !v || formats.isInn(v) || 'Введите ИНН или Выберите компанию из списка'
    const onChange = (model, fieldName, value) => this.onChange(model, fieldName, value)
    const onCompanyChange = (model, fieldName, value) => {
      console.log('onCompanyChange', fieldName, value)
      if (formats.isRefCode(value)) {
        let fobj = this.getFieldObject(fieldName)
        if (fobj) {
          fobj.fillRef(model, value, onChange)
        }
      } else {
        onChange(model, fieldName, value)
      }
    }
    const onSimpleChange = (model, fieldName, value) => {
      console.log('onSimpleChange', fieldName, value)
      let fobj = this.getFieldObject(fieldName)
      if (fobj) {
        fobj.fillRef(model, value, onChange)
      }
    }
    if (!fields) {
      this.props.scheme = []
      return this
    }
    const persistentHint = true
    var lScheme = []
    fields.forEach(f => {
      let fullFieldName = !f.target ? `${f.name}` : `/${f.target}/${f.name}`
      let fieldValue = f.value
      switch (f.type) {
        case 'company':
          lScheme.push({
            fieldType: 'v-chips-field',
            emptyChip: (model, field) => field.name !== model['postListField'] ? 'Выбрать' : 'Заполняется из списка',
            label: f.label,
            name: fullFieldName + '_CODE',
            defValue: f.value,
            disabled: (model, field) => (field.name === model['postListField']) || (f.value === 'self'),
            events: {
              'remove': () => {
                let fobj = this.getFieldObject(fullFieldName)
                if (fobj) {
                  fobj.setCode(this.model, null, onChange)
                }
              },
              'click': () => this.onClick(fullFieldName, onCompanyChange)
            },
            chipSize: 30,
            items: (model, field) => {
              return this.items.filter(i => i.fieldName === fullFieldName)
            },
            hint: (model, field) => {
              return f.hint
            },
            size: {sm12: true, xs12: true}
          })
          this.addFieldObject(this.createFieldObject(fullFieldName, f.value, f.type, f.def))
          this.addToModel(fullFieldName)
          break
        case 'json':
          this.addFieldObject(this.createFieldObject(fullFieldName, f.value, f.type, f.def))
          this.addToModel(fullFieldName)
          lScheme.push({
            fieldType: 'v-chips-field',
            emptyChip: 'Выбрать',
            label: f.label,
            name: fullFieldName + '_CODE',
            defValue: f.value,
            events: {
              'remove': () => {
                let fobj = this.getFieldObject(fullFieldName)
                if (fobj) {
                  fobj.setCode(this.model, null, onChange)
                }
              },
              'click': () => this.onClick(fullFieldName, onChange)
            },
            chipSize: 30,
            items: (model, field) => {
//              console.log('json', this.items.filter(i => i.fieldName === fullFieldName))
              return this.items.filter(i => i.fieldName === fullFieldName)
            },
            size: {sm12: true, xs12: true}
          })
          break
        case 'text':
          this.addFieldObject(new SimpleField(this, fullFieldName, 'TEXT', null, f.value))
          this.addToModel(fullFieldName)
          lScheme.push({
            fieldType: 'v-text-field',
            label: f.label,
            hint: f.hint,
            persistentHint: persistentHint,
            name: fullFieldName,
            size: {sm10: true}
          })
          break
        case 'macro':
          this.addFieldObject(new SimpleField(this, fullFieldName, 'TEXT', null, f.value))
          this.addToModel(fullFieldName)
          lScheme.push({
            fieldType: 'v-macro-field',
            label: f.label,
            hint: f.hint,
            persistentHint: persistentHint,
            name: fullFieldName,
            macro: true,
            heightEditor: this.calcHeighEditor(f.rows, f.type),
            events: {
              'check': (content) => this.onMacroCheck(fullFieldName, content)
            },
            size: {sm10: true}
          })
          break
        case 'email':
          this.addFieldObject(new SimpleField(this, fullFieldName, 'TEXT', null, f.value))
          this.addToModel(fullFieldName)
          lScheme.push({
            fieldType: 'v-text-field',
            label: f.label,
            hint: f.hint,
            persistentHint: persistentHint,
            name: fullFieldName,
            size: {sm10: true}
          })
          break
        case 'textarea':
          this.addFieldObject(new SimpleField(this, fullFieldName, 'TEXT', null, f.value))
          this.addToModel(fullFieldName)
          if (fullFieldName !== '/email-send/body') {
            lScheme.push({
              fieldType: 'v-textarea',
              label: f.label,
              hint: f.hint,
              persistentHint: persistentHint,
              name: fullFieldName,
              rows: f.rows > 0 ? f.rows : 1,
              size: {sm10: true}
            })
          } else {
            lScheme.push({
              fieldType: 'v-html-field',
              label: f.label,
              hint: f.hint,
              persistentHint: persistentHint,
              name: fullFieldName,
              macro: true,
              heightEditor: this.calcHeighEditor(f.rows, f.type),
              events: {
                'check': (content) => this.onMacroCheck(fullFieldName, content)
              },
              size: {sm10: true}
            })
          }
          break
        case 'html':
          this.addFieldObject(new SimpleField(this, fullFieldName, 'TEXT', null, f.value))
          this.addToModel(fullFieldName)
          lScheme.push({
            fieldType: 'v-html-field',
            label: f.label,
            hint: f.hint,
            persistentHint: persistentHint,
            name: fullFieldName,
            macro: true,
            heightEditor: this.calcHeighEditor(f.rows, f.type),
            events: {
              'check': (content) => this.onMacroCheck(fullFieldName, content)
            },
            size: {sm10: true}
          })
          break
        case 'date':
          this.addFieldObject(new SimpleField(this, fullFieldName, 'DATE', null, f.value))
          this.addToModel(fullFieldName)
          lScheme.push({
            fieldType: 'v-date-field',
            label: f.label,
            hint: f.hint,
            events: {
              'input': (value) => onSimpleChange(this.model, fullFieldName, value)
            },
            persistentHint: persistentHint,
            name: fullFieldName,
            size: {sm10: true}
          })
          break
        case 'select':
          this.addFieldObject(new SimpleField(this, fullFieldName, 'SELECT', null, fieldValue))
          this.addToModel(fullFieldName)
          lScheme.push({
            fieldType: 'v-select',
            label: f.label,
            hint: f.hint,
            items: f.options,
            persistentHint: persistentHint,
            name: fullFieldName,
            size: {sm10: true}
          })
          break
        case 'radio':
          this.addFieldObject(new SimpleField(this, fullFieldName, 'RADIO', null, fieldValue))
          this.addToModel(fullFieldName)
          lScheme.push({
            fieldType: 'v-select-radio',
            label: f.label,
            hint: f.hint,
            itemText: 'text',
            itemValue: 'value',
            items: f.options,
            persistentHint: persistentHint,
            name: fullFieldName,
            size: {sm10: true}
          })
          break
        case 'comment':
          lScheme.push({
            slot: f.value.replaceAll('[', '<').replaceAll(']', '>'),
            fieldType: 'v-flex',
            shrink: false,
            size: {sm10: true}
          })
          break
      }
    })
    this.props.scheme = lScheme
    return this
  }
  next (model, cb) {
    return cb(model)
  }
  addRef (fieldName, reference) {
    if (!reference) {
      return
    }
    if (this.refMap.get(reference)) {
      this.refMap.get(reference).add(fieldName)
    } else {
      this.refMap.set(reference, new Set([fieldName]))
    }
  }
  createFieldObject (fieldName, fieldValue, fieldType, fieldDef) {
    let type = null
    let ref = null
    switch (fieldType) {
      case 'company':
        type = 'COMPANY'
        matches = new RegExp('/{0,1}(self)').exec(fieldValue)
        if (matches) {
          ref = 'SELF'
        }
        return new CompanyField(this, fieldName, type, ref, fieldValue, fieldDef)
      case 'json':
        // let path = (new URL(fieldValue, 'http://parse')).pathname
        // console.log('createFieldObject', path)
        let matches = new RegExp('/fields/([^/]+)/([^/?]+)').exec(fieldValue)
        if (matches && matches.length > 2) {
          ref = `${matches[1]}`
          let t = matches[2].toUpperCase()
          if (t === 'BANK') {
            type = 'COMPANY_BANK'
            return new CompanyBankField(this, fieldName, type, ref, fieldValue)
          }
          if (t === 'HUMAN') {
            type = 'INDIVIDUAL'
            return new IndividualField(this, fieldName, type, ref, fieldValue, fieldDef)
          }
          if (t === 'CONTACT') {
            type = 'CONTACT'
            return new ContactField(this, fieldName, type, ref, fieldValue)
          }
          if (t === 'ACTION') {
            type = 'ACTION'
            return new ActionField(this, fieldName, type, ref, fieldValue)
          }
          if (t === 'FILES') {
            type = 'FILES'
            return new CompanyFilesField(this, fieldName, type, ref, fieldValue)
          }
          if (t === 'HOLDERS') {
            type = 'HOLDERS'
            return new HoldersField(this, fieldName, type, ref, fieldValue)
          }
          t = t.split('-').join('_')
          if (people.registeredTypeDoc().includes(t)) {
            type = t
            return new PersonDocField(this, fieldName, type, ref, fieldValue)
          }
          break
        }
        matches = new RegExp('^/human').exec(fieldValue)
        if (matches) {
          ref = 'LOCAL'
          type = 'INDIVIDUAL'
          return new IndividualField(this, fieldName, type, ref, fieldValue, fieldDef)
        }
        matches = new RegExp('^/calc$').exec(fieldValue)
        if (matches) {
          ref = 'LOCAL'
          type = 'CALC'
          return new CalcField(this, fieldName, type, ref, fieldValue)
        }
        matches = new RegExp('^/action$').exec(fieldValue)
        if (matches) {
          ref = 'LOCAL'
          type = 'ACTION'
          return new ActionField(this, fieldName, type, ref, fieldValue)
        }
        matches = new RegExp('^/me$').exec(fieldValue)
        if (matches) {
          ref = 'LOCAL'
          type = 'INDIVIDUAL'
          return new IndividualField(this, fieldName, type, ref, fieldValue, fieldDef)
        }
    }
    return new JsonField(this, fieldName, type, ref, fieldValue)
  }
  addFieldObject (fieldObject) {
    if (!fieldObject) {
      return
    }
    this.fieldObjects.set(fieldObject.name, fieldObject)
    this.addRef(fieldObject.name, fieldObject.ref)
  }
  getFieldObject (fieldName) {
    return this.fieldObjects.get(fieldName)
  }
  addToModel (fieldName, value) {
    let fobj = this.getFieldObject(fieldName)
    if (fobj) {
      fobj.init(this.model)
    } else {
      this.model[fieldName] = value != null ? value : null
    }
  }
  getReferencePerson (model, fieldName) {
    return new Promise((resolve, reject) => {
      let fobj = this.getFieldObject(fieldName)
      if (fobj) {
        // console.log('getReferencePerson', fobj, model)
        fobj = this.getFieldObject(fobj.ref)
        if (formats.isInnfl(model[fobj.name])) {
          let innfl = model[fobj.name]
          people.findIndividualByInn(innfl).then((individual) => {
            if (individual) {
              resolve(individual.id + '')
            } else {
              dialogs.message(null, 'Совет', 'Для использования данных физического лица нужно внести информацию')
            }
          })
          return
        }
        if (fobj.type === 'INDIVIDUAL') {
          if (fobj.getCode(model)) {
            resolve(fobj.getCode(model))
          } else {
            dialogs.message(null, 'Совет', 'Сначала выберите физическое лицо')
          }
        } else {
          reject()
        }
      } else {
        resolve(null)
      }
    })
  }
  getReferenceCompanyInn (model, fieldName) {
    let fobj = this.getFieldObject(fieldName)
    while (fobj && fobj.ref && fobj.type !== 'COMPANY') {
      fobj = this.getFieldObject(fobj.ref)
    }
    if (fobj && fobj.type === 'COMPANY') {
      let result = fobj.ref === 'SELF' ? model['companyInn'] : fobj.getValue(model)
      return result ? result.toString() : result
    }
    return null
  }
  getReferenceCompanyRefCode (model, fieldName) {
    let fobj = this.getFieldObject(fieldName)
    while (fobj && fobj.ref && fobj.type !== 'COMPANY') {
      fobj = this.getFieldObject(fobj.ref)
    }
    if (fobj && fobj.type === 'COMPANY') {
      let result = fobj.ref === 'SELF' ? model['companyRefCode'] : fobj.getCode(model)
      return result ? result.toString() : result
    }
    return null
  }
  updateItems (model) {
    let items = []
    this.fieldObjects.forEach((fobj) => {
      if (fobj.getCode(model)) {
        items.push({fieldName: fobj.name, value: fobj.getCode(model), text: fobj.getDescription(model), hint: fobj.getHint(model), error: null})
      }
    })
    this.items = items
    // console.log('updateItems', items)
  }
  onChange (model, fieldName, value) {
    console.log('onChange', fieldName, value)
    let fobj = this.getFieldObject(fieldName)
    if (!fobj.equalCode(model, value)) {
      console.log('onChange1', fieldName, value)
      fobj.clearRef(model)
      this.updateItems(model)
    }
  }
  onClick (fieldName, onChange) {
    console.log('onClick', fieldName)
    let fobj = this.getFieldObject(fieldName)
    if (fobj.getCode(this.model)) {
      return fobj.open(this.model, onChange)
    }
    return fobj.select(this.model, onChange)
  }
  onMacroCheck (fieldName, content) {
    this.context.macro(content).then(bodyHtml => {
      console.log('onMacroCheck', fieldName, bodyHtml)
      forms.openEditor(bodyHtml)
    })
  }
  setModel (model) {
    super.setModel(model)
    this.updateItems(model)
  }

}

export default {
  Step
}



// WEBPACK FOOTER //
// ./src/components/assist/StepSetParameters.js